import templateUrl from "servicestack/auto-query/auto-query-tag-filter.htm";
import controller from "servicestack/auto-query/auto-query-group-by-filter.controller";

export default {
  bindings: {
    filter: "<",
    hideCheckboxes: "@",
    hideEmptyGroupings: "@",
    hideGroupingCounts: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
